var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right_table"},[_c('div',[_c('edu-query',{ref:"cwQuery",attrs:{"code":"veJkyProject","do-filter":_vm.handleFilter}},[_c('template',{slot:"search"},[_c('edu-query-item',{attrs:{"title":"分类名称","pname":"name","pop":"like","stype":"input"}})],1)],2),_c('edu-table',{ref:"veJkyProjectTable",attrs:{"code":"veJkyProject","api":_vm.veJkyProjectTable.api,"get-params":_vm.getParams,"exportConfig":{
        url: 'veJkyGain/countCateExport',
        name: '《成果分类统计导出》'
      },"isAutoBtn":"","config":{
        pageFn: 'countCate',
        open: false,
        close: false,
        bdelete: false,
        status: false,
        checkBox: false
      }}},[_c('a-table-column',{attrs:{"title":"分类名称","dataIndex":"name","width":"150px"}}),_c('a-table-column',{attrs:{"title":"成果数量","dataIndex":"num","width":"150px"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }